module.exports = __webpack_public_path__ + "static/media/homework-card-footer.3342c23a.png";